import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";
const CounterDashboardReports = [
    {
        path: "counter-admin/reports-user-wise-sales",
        fullPath: "counter-admin/reports-user-wise-sales",
        exact: true,
        showChildren: false,
        sidebarMenu: true,
        displayName: "User Wise Sales",
        displayPath: "Reports > User Wise Sales",
        icon: AdjustmentsHorizontalIcon,
        children: [
            {
                index: true,
                async lazy() {
                    const component = await import(
                        "../../pages/Reports/CounterReports/UserWiseSales"
                    );
                    return {
                        Component: component.default,
                    };
                },
                permissions: ["reports-counter-user-wise-sales"],
            },
        ],
    },
    {
        path: "counter-admin/reports-counter-wise-sales",
        fullPath: "counter-admin/reports-counter-wise-sales",
        exact: true,
        showChildren: false,
        sidebarMenu: true,
        displayName: "Counter Wise Sales",
        displayPath: "Reports > Counter Wise Sales",
        icon: AdjustmentsHorizontalIcon,
        children: [
            {
                index: true,
                async lazy() {
                    const component = await import(
                        "../../pages/Reports/CounterReports/CounterWiseSales"
                    );
                    return {
                        Component: component.default,
                    };
                },
                permissions: ["reports-counter-wise-sales"],
            },
        ],
    },
    {
        path: "counter-admin/reports-user-wise-sales-summary",
        fullPath: "counter-admin/reports-user-wise-sales-summary",
        exact: true,
        showChildren: false,
        sidebarMenu: true,
        displayName: "User Wise Sales Summary",
        displayPath: "Reports > User Wise Sales Summary",
        icon: AdjustmentsHorizontalIcon,
        children: [
            {
                index: true,
                async lazy() {
                    const component = await import(
                        "../../pages/Reports/CounterReports/UserWiseSalesSummary"
                    );
                    return {
                        Component: component.default,
                    };
                },
                permissions: [
                    "reports-counter-user-wise-sales-summary",
                ],
            },
        ],
    },
    {
        path: "counter-admin/reports-new-counter-wise-sales",
        fullPath: "counter-admin/reports-new-counter-wise-sales",
        exact: true,
        showChildren: false,
        sidebarMenu: true,
        displayName: "New Counter Wise Sales",
        displayPath: "Reports > New Counter Wise Sales",
        icon: AdjustmentsHorizontalIcon,
        children: [
            {
                index: true,
                async lazy() {
                    const component = await import(
                        "../../pages/Reports/CounterReports/NewCounterWiseSales"
                    );
                    return {
                        Component: component.default,
                    };
                },
                permissions: [
                    "reports-new-counter-wise-sales",
                ],
            },
        ],
    },
    {
        path: "counter-admin/reports-old-user-sales-counter",
        fullPath: "counter-admin/reports-old-user-sales-counter",
        exact: true,
        showChildren: false,
        sidebarMenu: true,
        displayName: "Old User Sales Report",
        displayPath: "Reports > Old User Sales Report",
        icon: AdjustmentsHorizontalIcon,
        children: [
            {
                index: true,
                async lazy() {
                    const component = await import(
                        "../../pages/Reports/CounterReports/OldUserWiseSales"
                    );
                    return {
                        Component: component.default,
                    };
                },
                permissions: ["report-old-user-wise-sales-report"],
            },
        ],
    },

    {
        path: "counter-admin/reports-counter-prepaid-balance",
        fullPath: "counter-admin/reports-counter-prepaid-balance",
        exact: true,
        showChildren: false,
        sidebarMenu: true,
        displayName: "Counter Prepaid Balance",
        displayPath: "Reports > Counter Prepaid Balance",
        icon: AdjustmentsHorizontalIcon,
        children: [
            {
                index: true,
                async lazy() {
                    const component = await import(
                        "../../pages/Reports/CounterReports/CounterPrepaidBalance"
                    );
                    return {
                        Component: component.default,
                    };
                },
                permissions: ["reports-counter-prepaid-balance"],
            },
        ],
    },
];

export default CounterDashboardReports;
